import classNames from "classnames";
import cn from "classnames";

import stylesTris from "../../product/product-beauty-services.module.scss";

type Props = {
  hasServices?: boolean;
};

export default function SkeletonTris(props: Props) {
  return (
    <div className={classNames(stylesTris.mosaic, !props.hasServices && stylesTris.noServices)}>
      <div className={cn(stylesTris.mosaicMedia, "backgroundGradientLight")} />
      <div className={cn(stylesTris.mosaicMedia, "backgroundGradientLight")} />
      <div className={cn(stylesTris.mosaicMedia, "backgroundGradientLight")} />
    </div>
  );
}
